import { useEffect, useState } from "react";
import {
  addCustomerDisplayPaymentProgressListener,
  getCustomerDisplayPaymentProgress,
  type CustomerDisplayPaymentProgress,
} from "../lib/customer-display-payment-progress";

export function useCustomerDisplayPaymentProgress(): {
  paymentProgress: CustomerDisplayPaymentProgress | null;
} {
  const [paymentProgress, setPaymentProgress] = useState(() =>
    getCustomerDisplayPaymentProgress(),
  );

  useEffect(() => {
    const sync = () => setPaymentProgress(getCustomerDisplayPaymentProgress());
    const remove = addCustomerDisplayPaymentProgressListener(sync);
    const interval = setInterval(sync, 500);
    return () => {
      remove();
      clearInterval(interval);
    };
  }, []);

  return { paymentProgress };
}
